import React, { Suspense, useEffect, useCallback, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setFilters, resetFilters} from 'reducers/filtersSentEmailsSlice';
import { resetPagination } from 'reducers/paginationSentEmailsSlice';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ENDPOINT, LIMIT_PAGE } from "constants/variables";
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import TableSortingSentEmail  from "pages/sentemails/SortingTablesSentEmail";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews"; 
import SendEmailEdit from "pages/sentemails/SentEmailEdit";
import PropTypes from 'prop-types';

const initialFilters= {
  "idFrom":"",
  "idTo":"",
  "defaultStoreIdFrom":"",
  "defaultStoreIdTo":"",
  "dateEmailFrom":null,
  "dateEmailTo":null,
  "store_IdToFrom":"",
  "store_IdToTo":"", 
  "reasonFromES":"",
  "reasonToES":"",
  "reasonFromEN":"",
  "reasonToEN":"",
  "statusFromES":"",
  "statusToES":"",
  "statusFromEN":"",
  "statusToEN":"" 
};

const initialState = [{
  "id":"",
  "defaultStore_id":0, 
  "tradename": "",
  "useraccount_id":0,
  "username": "", 
  "createdate": null,
  "emailto": "",
  "subjectEmail":"",
  "contentEmail":"",
  "reason_id":0,
  "reason_namees":"",
  "reason_nameen":"",
  "status_id":0,
  "status_namees":"",
  "status_nameen":"" 
 }];

const headCells = [ 
  {
    id: 'createdate',
    numeric: false,
    disablePadding: false,
    label: 'Text_EMAIL_Date',
    canOrder:true,
  },
  {
    id: 'emailto',
    numeric: false,
    disablePadding: false,
    label: 'Text_EMAIL_Email',
    canOrder:true,
  },
  {
    id: 'subjectEmail',
    numeric: false,
    disablePadding: false,
    label: 'Text_SENDEMAIL_SUBJECT',
    canOrder:true,
  },
  {
    id: 'status_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_SENDEMAIL_STATUS',
    canOrder:true,
  },
  {
    id: 'reason_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_SENDEMAIL_REASON',
    canOrder:true,
  }
];

const initialStoresToSelect = [{
  "id": "",
  "documentid": "",
  "tradename": "",
  "name": ""
}];

const initialTypesToSelect = [{
  "id": "",
  "namees": "",
  "nameen": ""
}];

const SentEmailList = ({showModalSentEmails, setShowModalSentEmails}) => {
  const {t, i18n} = useTranslation(['listDataGeneralSettings']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);   
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const defaultStore_id = useSelector((state) => state.loginUser.defaultStore.id);  
  const [data, setData] = useState(initialState); 
  const filtersSentEmailsDetails = useSelector((state) => state.filtersSentEmails);
  const [filtersSentEmails, setFiltersSentEmails]= useState(initialFilters); 
  const [numTotReg,setNumTotReg]= useState(0);
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [errorsFilters, setErrorsFilters] = useState({}); 
  const [inputText, setInputText] = useState("");
  const [openDeleteRow,setOpenDeleteRow]= useState(false);
  const [idCodeDelete,setIdCodeDelete]=useState(DELETE_CODE);
  const [openEditRow,setOpenEditRow]= useState(false);
  const [openEditFilter,setOpenEditFilter]= useState(false);
  const [rowEdit,setRowEdit]= useState(initialState[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const dispatch = useDispatch();
  const [activeOffset, setActiveOffset]= useState(false);
  const [currencyOffset, setCurrencyOffset] = useState(1);
  const [rangeOffset, setRangeOffset] = useState([{}]); 
  const [storesToSelect,setStoresToSelect]= useState(initialStoresToSelect);  
  const [statusToSelect,setStatusToSelect]= useState(initialTypesToSelect);
  const [reasonToSelect,setReasonToSelect]= useState(initialTypesToSelect);
  const navigate = useNavigate(); 

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalSentEmails) {
        setData(initialState); 
        setNumTotReg(0);
        setNumTotRegFilter(0);
        setErrorsFilters({}); 
        setInputText(""); 
        setOpenDeleteRow(false);
        setIdCodeDelete(DELETE_CODE);
        setOpenEditFilter(false);
        setRowEdit(initialState[0]);
        setOpenEditRow(false); 
        setIsLoadingError(false); 
        setActiveOffset(false);
        setCurrencyOffset(1);
        setRangeOffset([{}]); 
        setStoresToSelect(initialStoresToSelect);
        setStatusToSelect(initialTypesToSelect);
        setReasonToSelect(initialTypesToSelect); 
        setShowModalSentEmails(false);
        dispatch(setLoading(false));
        dispatch(resetPagination());
        dispatch(resetFilters());
        setFiltersSentEmails(initialFilters); 
        navigate("/home");
        return () => {};
      }
    },
    [
      setData, 
      setFiltersSentEmails, 
      setNumTotReg,
      setNumTotRegFilter,
      setErrorsFilters, 
      setInputText, 
      setOpenDeleteRow,
      setOpenEditFilter,
      setRowEdit,
      setIdCodeDelete,  
      setOpenEditRow,
      setIsLoadingError, 
      setActiveOffset,
      setCurrencyOffset,
      setRangeOffset, 
      setStoresToSelect,
      setStatusToSelect,
      setReasonToSelect,
      showModalSentEmails, 
      setShowModalSentEmails,
      navigate,
      dispatch,
      DELETE_CODE
    ]
  );

  const closeModalSendEmailsSettings = () => {    
    setData(initialState); 
    setFiltersSentEmails(initialFilters);
    setNumTotReg(0);
    setNumTotRegFilter(0);
    setErrorsFilters({}); 
    setInputText(""); 
    setOpenDeleteRow(false);
    setOpenEditRow(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenEditFilter(false);
    setRowEdit(initialState[0]); 
    setIsLoadingError(false); 
    setActiveOffset(false);
    setCurrencyOffset(1);
    setRangeOffset([{}]); 
    setStatusToSelect(initialTypesToSelect);
    setStoresToSelect(initialStoresToSelect);
    setReasonToSelect(initialTypesToSelect); 
    setShowModalSentEmails(false);
    dispatch(setLoading(false));
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFiltersSentEmails(initialFilters); 
    navigate("/home");
    return () => {};
   };
 
  const openEditFilters = () => {
    setOpenEditFilter(!openEditFilter);
  };

  const handleSubmitFilterEdit = () => {
    setErrorsFilters(validateFormFilter());
    if (Object.keys(errorsFilters).length === 0) {
      setErrorsFilters({});
      dispatch(resetPagination());
      dispatch(setFilters(filtersSentEmails)); 
      setOpenEditFilter(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  
  const handleDeleteFilters = () => {
    setErrorsFilters({});
    dispatch(resetPagination());
    dispatch(resetFilters()); 
    setFiltersSentEmails(initialFilters);
    setOpenEditFilter(!openEditFilter);
  };

  const handleCancelFilters = () => {
    setErrorsFilters({});
    setOpenEditFilter(!openEditFilter);
  };
 
  const handleChangeFilterEdit = (e) => {
    const { name, value } = e.target;
    setFiltersSentEmails(filtersSentEmails => ({
      ...filtersSentEmails,
      [name]: value
    }));
  };

  const handleBlurFilterEdit = (e) => {
    setErrorsFilters(validateFormFilter());
    handleChangeFilterEdit(e);
  };

  const handleBlurSelectDateFrom = (e) => {
    handleChangeSelectDateFrom(e);
    setErrorsFilters(validateFormFilter()); 
  };

  const handleChangeSelectDateFrom = (event) => {
    setFiltersSentEmails(filtersSentEmails => ({
      ...filtersSentEmails,
      dateEmailFrom: event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectDateTo = (e) => {
    handleChangeSelectDateTo(e);
    setErrorsFilters(validateFormFilter()); 
  };

  const handleChangeSelectDateTo = (event) => {
    setFiltersSentEmails(filtersSentEmails => ({
      ...filtersSentEmails,
      dateEmailTo: event!==null?new Date(event):null
    }));
  };

  const toggleDrawerFilterEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      setErrorsFilters({});
      setFiltersSentEmails(initialFilters);
      setOpenEditFilter(!openEditFilter);
    }
  };

  const validateFormFilter = () => {
    let errorsFilters = {};
    let regexNumber = /^[0-9]+$/;
    if (filtersSentEmails.idFrom!=="" & !regexNumber.test(filtersSentEmails.idFrom)) {
      errorsFilters.idFrom = 'Text_TextNoNumber';
    }
    if (filtersSentEmails.idTo!=="" & !regexNumber.test(filtersSentEmails.idTo)) {
      errorsFilters.idTo = 'Text_TextNoNumber';
    }
    if (filtersSentEmails.idFrom!=="" & !errorsFilters.idFrom!==undefined){
      if (filtersSentEmails.idTo!=="" & !errorsFilters.idTo!==undefined){
        if (parseInt(filtersSentEmails.idTo)<parseInt(filtersSentEmails.idFrom)){
          errorsFilters.idTo = 'Text_TextGreater_Id';
        }
      }
    } 
    return errorsFilters;
  }  

  const filteredData = data.filter((el) => {
    if (inputText === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +
        String(el.emailto || '') +
        String(el.subjectEmail || '');
      let result = dataTranslate.toLowerCase().includes(inputText.toLowerCase());
      return result;
    }
  })

  let inputHandler = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };
 
  const handleCloseDataEdit = () => { 
    setOpenDeleteRow(false); 
    setRowEdit(initialState[0]); 
    dispatch(setLoading(false));
    setIsLoadingError(false); 
    toggleDrawerDataEdit(false);
	}; 
 
  const handleChangeDeleteRow = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };
  
  const handleCancelDeleteRow = () => {
    setRowEdit(initialState[0]);
    dispatch(setLoading(false));
    setIsLoadingError(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
  };

  const handleCloseDeleteRow = (e) => {
    if (idCodeDelete !== DELETE_CODE) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    let isMounted = true;
    if (e.key !== 'Escape') {
      if (rowEdit.id !== '') {
     
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT, `api/deletesendemail`, token, rowEdit);
            if (getData.status === "OK") {
              if (isMounted) {
                dispatch(successErrorAction(t('Text_ValidCode')));
                dispatch(successErrorAction(t('Text_DeleteField')));
              }
            } else {
              if (isMounted) {
                dispatch(warningErrorAction(t(getData.cause)));
              }
            }
            dispatch(setLoading(false)); 
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }
        }; 
        fetchData(); 
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    }
    setIsLoadingError(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
    handleCloseDataEdit();
    return () => { isMounted = false;};
  };
  
  const toggleDrawerDataEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault()
      handleCloseDataEdit();
    }
  };
 
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (numTotRegFilter>LIMIT_PAGE){
      setActiveOffset(true);
      setRangeOffset([
        { value: 0,
          label: " 1 - "+Number(LIMIT_PAGE).toLocaleString('de-DE'),
        }
      ]);
      for (let i = Number(LIMIT_PAGE); i<numTotRegFilter; i=i+ Number(LIMIT_PAGE)){
        setRangeOffset(
          current=>[
            ...current,
            ...[
              {
                value: i,
                label: " "+(i+1).toLocaleString('de-DE')+" - "+(i+Number(LIMIT_PAGE)).toLocaleString('de-DE'),
              }
            ]
          ]
        )
      }
    } else{
      setCurrencyOffset(0);
      setActiveOffset(false);
      setRangeOffset([{}]);
    }
  },[numTotRegFilter]);

  useEffect(() => {
    let isMounted = true; 
    
    const fetchDataStore = async () => {
        try {
          const getData = await helpHttp().get(ENDPOINT,`api/storesorderbytradename`,token);
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setStoresToSelect(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      }; 
      
    const fetchDataStatus = async () => {
      try {
        const getData = i18n.language==='es'?
          await helpHttp().get(ENDPOINT,`statustype/simplestatustypeBynamees`,token):
          await helpHttp().get(ENDPOINT,`statustype/simplestatustypeBynameen`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setStatusToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchDataReason = async () => {
      try {
        const getData = i18n.language==='es'?
          await helpHttp().get(ENDPOINT,`reasontype/simplereasontypeBynamees`,token):
          await helpHttp().get(ENDPOINT,`reasontype/simplereasontypeBynameen`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setReasonToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 

    if (setShowModalSentEmails ) { 
      if (roles[0].listmenus.find((key)=>(key.name==='View_EMAILS_ALL_STORES'))){
        fetchDataStore();
      } 
      fetchDataStatus();
      fetchDataReason();
    }
    return () => { isMounted = false };

  }, [t,token,i18n,dispatch,roles,setShowModalSentEmails,defaultStore_id]);
   
  
  useEffect(() => {
    let ignore = false;  
    const fetchnumTotReg = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `api/getinformationtablesentemail`, token);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotReg(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
  
    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = await helpHttp().post2(ENDPOINT, `api/getcountfiltersentemail`, token, "-1",filtersSentEmailsDetails);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
  
    const fetchData = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().post4(ENDPOINT, `api/getsendemails`, token, currencyOffset, LIMIT_PAGE, "-1",filtersSentEmailsDetails);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setData(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
  
    if (showModalSentEmails) {
      fetchnumTotReg();
      fetchnumTotRegFilter();
      fetchData();
      return () => { ignore = true; };
    }
  }, [ t, token, dispatch, openDeleteRow, showModalSentEmails, filtersSentEmailsDetails, currencyOffset]);
  
  return (
    <>
      {showModalSentEmails ? ( 
        <div className="container-fluid formdi-pending-page">
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingError?
              <i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>
              :isLoadingData?
              <CircularProgress color={"primary"}/>:
              <i className="fas fa-solid fa-envelope text-warning"></i>} {t('Text_MAIL_List')}
            </h1>
            {isLoadingData ?
              <CircularProgress sx={{ color : "#f6c23e"}}/>:
                <div>
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalSendEmailsSettings} >
                    {t('Button_Back')}
                  </button>
                </div>
            }
          </div>  
          <br/>   
          {!isLoadingData ?
          <>
            {/* Buscador */}
            <div className="formdi-pending-search">
              <TextField
                id="outlined-basic"
                variant="outlined"
                value={inputText}
                inputProps={{ style: {fontSize: '18px'} }}
                InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
                placeholder={t('Text_EMAIL_Search')}
                onChange={inputHandler}
                fullWidth
                label={t('Text_EMAIL_Search')}>
              </TextField>
            </div>
            <br/>
            <div id="myNewDIV" className="formdi-pending-filters">
              <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
              <div className="formdi-pending-filters-row">
                {roles[0].listmenus.find((key)=>(key.name==="View_EMAILS_ALL_STORES"))&&
                  <>
                    <button type="button" className={`formdi-pending-chip ${filtersSentEmailsDetails.defaultStoreIdFrom !== "" || filtersSentEmailsDetails.defaultStoreIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                      <span className={`formdi-pending-dot ${ filtersSentEmailsDetails.defaultStoreIdFrom !== "" || filtersSentEmailsDetails.defaultStoreIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_ENDEMAIL_Store")}
                    </button>
                  </>
                } 
                <button type="button" className={`formdi-pending-chip ${filtersSentEmailsDetails.store_IdToFrom !== "" || filtersSentEmailsDetails.store_IdToTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${ filtersSentEmailsDetails.store_IdToFrom !== "" || filtersSentEmailsDetails.store_IdToTo !== ""? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_SENDEMAIL_Email")}
                </button>
                <button type="button" className={`formdi-pending-chip ${filtersSentEmailsDetails.dateEmailFrom!==null || filtersSentEmailsDetails.dateEmailTo!==null ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${filtersSentEmailsDetails.dateEmailFrom!==null || filtersSentEmailsDetails.dateEmailTo!==null ? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_SENDEMAIL_Date")}
                </button> 
                
                <button type="button" className={`formdi-pending-chip ${filtersSentEmailsDetails.statusFromES !== "" || filtersSentEmailsDetails.statusToES !== "" || filtersSentEmailsDetails.statusFromEN || filtersSentEmailsDetails.statusToEN!==""? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${ filtersSentEmailsDetails.statusFromES !== "" || filtersSentEmailsDetails.statusToES !== "" || filtersSentEmailsDetails.statusFromEN!=="" || filtersSentEmailsDetails.statusToEN!==""? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_SENDEMAIL_STATUS")}
                </button> 
                 <button type="button" className={`formdi-pending-chip ${filtersSentEmailsDetails.reasonFromES !== "" || filtersSentEmailsDetails.reasonToES !== "" || filtersSentEmailsDetails.reasonFromEN!=="" || filtersSentEmailsDetails.reasonToEN!==""? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${ filtersSentEmailsDetails.reasonFromES !== "" || filtersSentEmailsDetails.reasonToES !== "" || filtersSentEmailsDetails.reasonFromEN!=="" || filtersSentEmailsDetails.reasonToEN!==""? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_SENDEMAIL_REASON")}
                </button>
               </div>
            </div>
            <br/> 
            <div className="formdi-pending-card-flat">
              <div className="formdi-pending-card-content">
                <TableSortingSentEmail
                  data={filteredData}
                  headCells={headCells}
                  numTotRegFilter={numTotRegFilter}
                  titleTable={t('Text_EMAIL_Table')}
                  setOpenDeleteRow={setOpenDeleteRow}
                  setOpenEditRow={setOpenEditRow}
                  setRowEdit={setRowEdit}
                  showDeleteButton={roles[0].listmenus.find((key)=>(key.name==='Handle_Delete_EMAILS'))?true:false}
                  numTotReg={numTotReg}
                  activeOffset={activeOffset}
                  rangeOffset={rangeOffset}
                  currencyOffset={currencyOffset}
                  setCurrencyOffset={setCurrencyOffset}
                >
                </TableSortingSentEmail>
              </div>             
            </div>
            {openEditFilter &&
              <div>
                <SwipeableDrawer
                  anchor='right'
                  open={true}
                  onClose={toggleDrawerFilterEdit(false)}
                  onOpen={toggleDrawerFilterEdit(true)}>
                  <Container >
                    <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                      <br/>
                      <div id="myDIV">
                        <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                      </div>
                      <hr className="sidebar-divider d-none d-md-block"/>
                      <form className="createfilter" onSubmit={handleCancelFilters}>  
                        <div className="form-floating mb-3 px-4 primary">
                          {roles[0].listmenus.find((key)=>(key.name==='View_EMAILS_ALL_STORES'))   &&
                          <>
                            <Suspense delayMs={500} fallback={<CircularProgress sx={{ color :"#f6c23e"}}/>}>
                              <div className="form-group">
                                <TextField
                                  id="defaultStoreIdFrom"
                                  name="defaultStoreIdFrom"
                                  value={filtersSentEmails.defaultStoreIdFrom}
                                  inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                  label={errorsFilters.defaultStoreIdFrom!=null?t(errorsFilters.defaultStoreIdFrom):t('Text_Filter_Stores_From')}
                                  placeholder={t('PlaceHolder_Filter_Store_From')}
                                  variant="outlined"
                                  onBlur={handleBlurFilterEdit}
                                  onChange={handleChangeFilterEdit}
                                  select
                                  SelectProps={{
                                  native: true,
                                  }}>
                                  <option key={0} value=""/>
                                  {storesToSelect.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.documentid+" - "+option.tradename}
                                    </option>
                                  ))}
                                </TextField>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                <TextField
                                  id="defaultStoreIdTo"
                                  name="defaultStoreIdTo"
                                  value={filtersSentEmails.defaultStoreIdTo}  
                                  inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                  label={errorsFilters.defaultStoreIdTo!=null?t(errorsFilters.defaultStoreIdTo):t('Text_Filter_Stores_To')}
                                  placeholder={t('PlaceHolder_Filter_Store_to')}
                                  variant="outlined"
                                  onBlur={handleBlurFilterEdit}
                                  onChange={handleChangeFilterEdit}
                                  select
                                  SelectProps={{
                                  native: true,
                                  }}>
                                    <option key={0} value=""/>
                                  {storesToSelect.filter(item=>(item.id>=filtersSentEmails.defaultStoreIdFrom)).map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.documentid+" - "+option.tradename}
                                    </option>
                                  ))}
                                </TextField>
                              </div>
                            </Suspense>
                          </>
                        }   
                          <div className="form-group">
                            <TextField
                              id="store_IdToFrom"
                              name="store_IdToFrom"
                              value={filtersSentEmails.store_IdToFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFilters.store_IdToFrom!=null?t(errorsFilters.store_IdToFrom):t('Text_Filter_Stores_From')}
                              placeholder={t('PlaceHolder_Filter_Store_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit} 
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                            <TextField
                              id="store_IdToTo"
                              name="store_IdToTo"
                              value={filtersSentEmails.store_IdToTo}  
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFilters.store_IdToTo!=null?t(errorsFilters.store_IdToTo):t('Text_Filter_Stores_To')}
                              placeholder={t('PlaceHolder_Filter_Store_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}
                            />
                          </div>
                              
                          <div className="form-group">
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                              <DesktopDatePicker
                                id="dateEmailFrom" 
                                name="dateEmailFrom"
                                value={ filtersSentEmails.dateEmailFrom!== null ? new Date(filtersSentEmails.dateEmailFrom): null}
                                format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                label={errorsFilters.dateEmailFrom!=null?t(errorsFilters.dateEmailFrom):t('Text_Filter_EMAIL_Date_From')}
                                onBlur={handleBlurSelectDateFrom}
                                onChange={handleChangeSelectDateFrom}
                                slotProps={{
                                  textField: {
                                    placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                    sx: {
                                      color: '#1565c0',
                                      maxLength: '100',
                                      width: 430,  
                                      fontSize: '18px'
                                    },
                                    InputProps: {
                                      style: {
                                        fontSize: '18px',
                                      }
                                    },
                                    InputLabelProps:{ 
                                      style: {
                                        fontSize: '18px', 
                                        background: '#FFFFFF'
                                      }
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                           <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                              <DesktopDatePicker
                                id="dateEmailTo" 
                                name="dateEmailTo"
                                minDate={filtersSentEmails.dateEmailFrom!== null ? new Date(filtersSentEmails.dateEmailFrom): null}
                                value={ filtersSentEmails.dateEmailTo!== null ? new Date(filtersSentEmails.dateEmailTo): null}
                                format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                label={errorsFilters.dateEmailTo!=null?t(errorsFilters.dateEmailTo):t('Text_Filter_EMAIL_Date_To')}
                                onBlur={handleBlurSelectDateTo}
                                onChange={handleChangeSelectDateTo}
                                slotProps={{
                                  textField: {
                                    placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                    sx: {
                                      color: '#1565c0',
                                      maxLength: '100',
                                      width: 430,  
                                      fontSize: '18px'
                                    },
                                    InputProps: {
                                      style: {
                                        fontSize: '18px',
                                      }
                                    },
                                    InputLabelProps:{ 
                                      style: {
                                        fontSize: '18px', 
                                        background: '#FFFFFF'
                                      }
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </div>     
                          <Suspense delayMs={500} fallback={<CircularProgress sx={{ color :"#f6c23e"}}/>}>
                            <div className="form-group">
                              <TextField
                                id={i18n.language==="es"?"statusFromES":"statusFromEN"}
                                name={i18n.language==="es"?"statusFromES":"statusFromEN"}
                                value={i18n.language==="es"?filtersSentEmails.statusFromES:filtersSentEmails.statusFromEN}
                                inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                label={i18n.language==="es"?errorsFilters.statusFromES!=null?t(errorsFilters.statusFromES):t('Text_Filter_Status_From'):errorsFilters.statusFromEN!=null?t(errorsFilters.statusFromEN):t('Text_Filter_Status_From')}
                                placeholder={t('PlaceHolder_Filter_Status_From')}
                                variant="outlined"
                                onBlur={handleBlurFilterEdit}
                                onChange={handleChangeFilterEdit}
                                select
                                SelectProps={{
                                native: true,
                                }}>
                                <option key={0} value=""/>
                                {statusToSelect.map((option) => (
                                <option key={option.id} value={i18n.language==="es"?option.namees:option.nameen}>
                                    {i18n.language==="es"?option.namees:option.nameen}
                                </option>
                                ))}
                              </TextField>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                              <TextField
                                id={i18n.language==="es"?"statusToES":"statusToEN"}
                                name={i18n.language==="es"?"statusToES":"statusToEN"}
                                value={i18n.language==="es"?filtersSentEmails.statusToES:filtersSentEmails.statusToEN}
                                inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                label={i18n.language==="es"?errorsFilters.statusToES!=null?t(errorsFilters.statusToES):t('Text_Filter_Status_To'):errorsFilters.statusToEN!=null?t(errorsFilters.statusToEN):t('Text_Filter_Status_To')}
                                placeholder={t('PlaceHolder_Filter_Status_To')}
                                variant="outlined"
                                onBlur={handleBlurFilterEdit}
                                onChange={handleChangeFilterEdit}
                                select
                                SelectProps={{
                                native: true,
                                }}>
                                <option key={0} value=""/>
                                {statusToSelect.filter(item=>(i18n.language==="es"?item.namees>=filtersSentEmails.statusFromES:item.nameen>=filtersSentEmails.statusFromEN)).map(option => (
                                <option key={option.id} value={i18n.language==="es"?option.namees:option.nameen}>
                                    {i18n.language==="es"?option.namees:option.nameen}
                                </option>
                                ))}
                              </TextField>
                            </div>

                            <div className="form-group">
                              <TextField
                                id={i18n.language==="es"?"reasonFromES":"reasonFromEN"}
                                name={i18n.language==="es"?"reasonFromES":"reasonFromEN"}
                                value={i18n.language==="es"?filtersSentEmails.reasonFromES:filtersSentEmails.reasonFromEN}
                                inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                label={i18n.language==="es"?errorsFilters.reasonFromES!=null?t(errorsFilters.reasonFromES):t('Text_Filter_Reason_From'):errorsFilters.reasonFromEN!=null?t(errorsFilters.reasonFromEN):t('Text_Filter_Reason_From')}
                                placeholder={t('PlaceHolder_Filter_Reason_From')}
                                variant="outlined"
                                onBlur={handleBlurFilterEdit}
                                onChange={handleChangeFilterEdit}
                                select
                                SelectProps={{
                                native: true,
                                }}>
                                <option key={0} value=""/>
                                {reasonToSelect.map((option) => (
                                <option key={option.id} value={i18n.language==="es"?option.namees:option.nameen}>
                                    {i18n.language==="es"?option.namees:option.nameen}
                                </option>
                                ))}
                              </TextField>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                              <TextField
                                id={i18n.language==="es"?"reasonToES":"reasonToEN"}
                                name={i18n.language==="es"?"reasonToES":"reasonToEN"}
                                value={i18n.language==="es"?filtersSentEmails.reasonToES:filtersSentEmails.reasonToEN}
                                inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                label={i18n.language==="es"?errorsFilters.reasonToES!=null?t(errorsFilters.reasonToES):t('Text_Filter_Reason_To'):errorsFilters.reasonToEN!=null?t(errorsFilters.reasonToEN):t('Text_Filter_Reason_To')}
                                placeholder={t('PlaceHolder_Filter_Reason_To')}
                                variant="outlined"
                                onBlur={handleBlurFilterEdit}
                                onChange={handleChangeFilterEdit}
                                select
                                SelectProps={{
                                native: true,
                                }}>
                                <option key={0} value=""/>
                                {reasonToSelect.filter(item=>(i18n.language==="es"?item.namees>=filtersSentEmails.reasonFromES:item.nameen>=filtersSentEmails.reasonFromEN)).map(option => (
                                <option key={option.id} value={i18n.language==="es"?option.namees:option.nameen}>
                                    {i18n.language==="es"?option.namees:option.nameen}
                                </option>
                                ))}
                              </TextField>
                            </div>
                            
                          </Suspense>
                          <hr className="sidebar-divider d-none d-md-block" />
                          <div className="formdi-pending-action-group">
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEdit}>
                              {t('Button_Apply')}
                            </button> 
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFilters}>
                              {t('Button_Cancel_Filters')}
                            </button>
                          </div>
                        </div>
                      </form>
                    </Box>
                  </Container>
                </SwipeableDrawer>
              </div>
            }
            <SendEmailEdit
              openEditRow={openEditRow}
              setOpenEditRow={setOpenEditRow}
              rowEdit={rowEdit}>
            </SendEmailEdit>
            <Dialog open={openDeleteRow} onClose={handleCancelDeleteRow} PaperProps={{ className: "my-dialog-paper-danger" }} >
              <DialogTitle className="my-dialog-title-danger">
                {t('Text_Delete')} {rowEdit.id}  - {rowEdit.emailto}
              </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText-danger">
                    {t("Text_Line1")}<br />
                    {t("Text_Line2")}
                  </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="idCode"
                      label={t("Text_Label")}
                      type="text"
                      fullWidth
                      variant="standard"
                      className="my-dialog-input-danger"
                      defaultValue={idCodeDelete}
                      onChange={handleChangeDeleteRow}
                    />
                  </DialogContent>
                <DialogActions className="my-dialog-actions">
                <Button
                  onClick={handleCancelDeleteRow}
                  className="my-dialog-button-cancel-danger"
                >
                  {t("Button_Cancel")}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleCloseDeleteRow}
                  className="my-dialog-button-delete"
                >
                  {t("Button_Delete")}
                </Button>
              </DialogActions>
            </Dialog>    
            {/* End Content Row */}
          </>:
            <LoadingNews/>
          }
        </div>
        //* End Page Content *//
      ) :  null }
    </>
  )
}

SentEmailList.propTypes = {
  showModalSentEmails: PropTypes.bool.isRequired,
  setShowModalSentEmails: PropTypes.func.isRequired   
};

export default SentEmailList;